<div _ngcontent-igw-c384="" class="ng-star-inserted" style=" text-align: center;    margin-top: 12vh;">
  <div>
    <img _ngcontent-igw-c384="" src="assets/images/empty.png" style=" width: 4rem;">
  </div>
  <div style=" margin-top: 10px; margin-bottom: 13px;">
    <span _ngcontent-igw-c384="" style="
        font-size: 1.2em;
        font-weight: 800;
        color: #686464;
        font-weight: 100;

    ">{{ message | translate}}</span></div>
    <ng-content #name></ng-content>

</div>
